import type { Language } from '@hemmafixa/ui';
import { createContext, useContext } from 'react';
import type { Messages } from './sv';

export interface I18n {
  language: Language;
  setLanguage: (language: Language) => void;
  /** Typed texts: `t.nav.overview`. Fill {placeholders} with `fill`. */
  t: Messages;
  money: (ore: number) => string;
  date: (iso: string) => string;
  /** Date and time, for logs: "23 okt. 2026 12:30" */
  dateTime: (iso: string) => string;
  /** "3 days ago", "in 2 hours" */
  relative: (iso: string) => string;
}

export const I18nContext = createContext<I18n | null>(null);

export function useI18n() {
  const context = useContext(I18nContext);
  if (!context) throw new Error('useI18n must be used inside I18nProvider');
  return context;
}

/** Fills `{name}` placeholders: fill('Hi {name}', { name: 'Anna' }). */
export function fill(template: string, values: Record<string, string | number>) {
  return template.replace(/\{(\w+)\}/g, (match, key: string) => String(values[key] ?? match));
}
